module.exports = __webpack_public_path__ + "static/img/sgsw1.bac2d9e.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/sgsw1.svg
// module id = 6foh
// module chunks = 1